import module_88fc34138ba94c63af1edc258dd9886f from '../includes/glsl-compat.frag'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\nprecision '+
(obj.highp)+
' float;\n\n'+
(module_88fc34138ba94c63af1edc258dd9886f())+
'\n\n\nIN vec2 vTexCoord;\nuniform float uReveal;\n\nvoid main(void){\n  float alpha = clamp(smoothstep(1.0, 0.99, length(vTexCoord)), 0.0, 1.0);\n  FragColor = vec4(vec3(0.31, 0.64, 0.74), alpha * uReveal);\n}\n';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
